<template>
  <details class="pi-legend" :open="startOpen">
    <summary class="pi-legend__summary">{{ title }}</summary>
    <dl class="pi-legend__list">
      <div v-for="entry in entries" :key="entry.key" class="pi-legend__item">
        <dt><span class="pi-badge" :class="'pi-badge--' + entry.tone">{{ entry.label }}</span></dt>
        <dd>{{ entry.text }}</dd>
      </div>
    </dl>
  </details>
</template>

<script>
export default {
  name: "pi-legend",
  props: {
    entries: { type: Array, default: () => [] },
    title: { type: String, default: "O que significa cada situação" },
    startOpen: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.pi-legend {
  margin: 0 0 12px;
  border: 1px solid #e6e7eb;
  border-radius: 6px;
  background: #fafbfc;
}

.pi-legend__summary {
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  color: #1d12b9;
  cursor: pointer;
}

.pi-legend__summary:focus {
  outline: 2px solid #1b59f8;
  outline-offset: -2px;
}

.pi-legend__list {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px 24px;
  margin: 0;
  padding: 4px 12px 12px;
}

@media (min-width: 992px) {
  .pi-legend__list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.pi-legend__item {
  display: flex;
  gap: 10px;
  align-items: baseline;
}

.pi-legend__item dt {
  flex: 0 0 150px;
  font-weight: 400;
}

.pi-legend__item dd {
  margin: 0;
  font-size: 12px;
  line-height: 1.45;
  color: #3a424e;
}

@media (max-width: 767px) {
  .pi-legend__item {
    flex-direction: column;
    gap: 4px;
  }

  .pi-legend__item dt {
    flex-basis: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piLegend.vue